import { render, staticRenderFns } from "./_currencyExchanges.vue?vue&type=template&id=7e8dd456&scoped=true&"
import script from "./_currencyExchanges.vue?vue&type=script&lang=js&"
export * from "./_currencyExchanges.vue?vue&type=script&lang=js&"
import style0 from "./_currencyExchanges.vue?vue&type=style&index=0&id=7e8dd456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8dd456",
  null
  
)

export default component.exports